import type { ChangeEvent } from 'react';
import InputAdornment from '@mui/material/InputAdornment';
import MuiTextField from '@mui/material/TextField';
import { TimeIcon } from '@/icons';
import { classes, formatTimeString, parseTimeString, styles } from './utils';

export type TimeInputProps = {
  value: Date | null | undefined;
  onChange: (update: { hours: number; minutes: number }) => void;
};

export default function TimeInput({ value, onChange }: TimeInputProps) {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const parsed = parseTimeString(e.target.value);
    if (!parsed) return;
    onChange(parsed);
  };

  return (
    <MuiTextField
      sx={styles.timeField}
      className={classes.timeField}
      variant="standard"
      size="small"
      type="time"
      value={formatTimeString(value)}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <TimeIcon aria-hidden className={classes.timeIcon} />
          </InputAdornment>
        ),
      }}
      onChange={handleChange}
    />
  );
}
